import { render, staticRenderFns } from "./EditRoleForm.vue?vue&type=template&id=ff593d32&"
import script from "./EditRoleForm.vue?vue&type=script&lang=js&"
export * from "./EditRoleForm.vue?vue&type=script&lang=js&"
import style0 from "../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports